import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiCheck } from 'react-icons/fi';

const Testimonials = ({ onOpenModal }) => {
  const videoTestimonials = [
    {
      url: "https://storage-eu.elkqr.com/users/3843/workspaces/3682/videos/20260127_020841_50a050f4.mp4",
      autoplay: false,
      fit: "contain"
    },
    {
      url: "https://storage.googleapis.com/msgsndr/so5Q2Nu9nHUt6xGc9h1D/media/69782bcfc1fa0c4b09e950a1.mp4",
      autoplay: true,
      fit: "cover"
    },
    {
      url: "https://storage.googleapis.com/msgsndr/so5Q2Nu9nHUt6xGc9h1D/media/69782bcfd4fb90365f2d7a6d.mp4",
      autoplay: true,
      fit: "cover"
    },
    {
      url: "https://storage.googleapis.com/msgsndr/so5Q2Nu9nHUt6xGc9h1D/media/69782bcfc1fa0c7f7ce950a3.mp4",
      autoplay: true,
      fit: "cover"
    }
  ];

  const images = [
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020809_a09fffa6.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020810_0e1ba933.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020810_8927ea84.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020811_9a37e6ec.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020812_6814f40c.png",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020812_a3627bcc.png",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020813_e891ffb6.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020813_8ef6e801.png",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020814_262ec467.png",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020814_a392ff47.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020815_bfe205a1.png",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020815_13c486be.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020816_275a3526.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020816_b405dbe7.jpg",
    "https://storage-eu.elkqr.com/users/3843/workspaces/3682/images/20260127_020816_c29228e9.jpg"
  ];

  return (
    <section id="testimonials" className="py-24 bg-black-pure relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10 max-w-6xl">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-7xl font-black text-white mb-6 uppercase tracking-tighter">
            RISULTATI <span className="text-purple-500 italic">REALI</span>
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Video Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {videoTestimonials.map((video, index) => (
            <motion.div 
              key={`video-${index}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`relative w-full overflow-hidden rounded-[2rem] border-4 border-slate-800 shadow-2xl bg-black aspect-video ${index === 0 ? 'md:col-span-2' : ''}`}
            >
              <video 
                controls 
                playsInline 
                muted={video.autoplay}
                autoPlay={video.autoplay}
                loop={video.autoplay}
                className="absolute top-0 left-0 w-full h-full"
                style={{ objectFit: video.fit }}
                preload="metadata"
              >
                <source src={video.url} type="video/mp4" />
                Browser non supportato
              </video>
            </motion.div>
          ))}
        </div>

        {/* Image Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {images.map((url, index) => (
            <motion.div 
              key={`img-${index}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: (index % 6) * 0.1 }}
              className="group relative rounded-3xl overflow-hidden border border-white/10"
            >
              <img 
                src={url} 
                alt={`Testimonial ${index + 1}`} 
                loading="lazy"
                className="w-full h-auto block transform group-hover:scale-105 transition-transform duration-700" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                <div className="flex items-center space-x-2 text-white font-bold text-sm">
                  <div className="w-5 h-5 bg-purple-500 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiCheck} className="text-xs" />
                  </div>
                  <span className="uppercase tracking-widest">Risultato Verificato</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-center">
          <button 
            onClick={onOpenModal}
            className="btn-premium text-white px-12 py-5 rounded-2xl font-black text-xl flex items-center space-x-3 shadow-[0_0_50px_rgba(147,51,234,0.3)] hover:shadow-[0_0_70px_rgba(147,51,234,0.5)] transition-all duration-300"
          >
            <span>Iscriviti Ora</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;